export default __webpack_public_path__ + "images/license-riskop-1.16a78425d46d8e106e9fa26bb5d93a8b.png";